<template lang="pug">
  .row
    //TODO extract
    .columns.large-24
      article.content-block.floating-block(:class="{'hidden': bottom}")
        section.content.reverse-button-order

          router-link(:to="cancelLink" class='button secondary left') {{t('app.buttons.cancel')}}
          .submit-disable.right.with-not-saved
            span(v-if="registration.isDraft() && current_organization.isBlank()")
              a(class='button secondary save_and_finish_later', @click.prevent="submitRegistration({later: true})") {{t('app.programs.save_and_finish')}}
            button.button.save_and_continue(@click.prevent="submitRegistration", type='submit' disabled1="!form_valid")
              span(v-if="current_organization.id") {{t('app.programs.save_and_continue')}}
              span(v-else-if="registration.isCorrectionRequired()") {{t('app.programs.save_and_submit')}}
              span(v-else-if="registration.isCompleted()") {{t('app.buttons.save')}}
              span(v-else) {{t('app.programs.continue')}}

            .not-saved(v-html="t('app.registration.do_not_double_click')")
          .clearfix
      article.content-block
        section.content.reverse-button-order

          router-link(:to="cancelLink" class='button secondary left') {{t('app.buttons.cancel')}}
          .submit-disable.right.with-not-saved
            span(v-if="registration.isDraft() && current_organization.isBlank()")
              a(class='button secondary save_and_finish_later', @click.prevent="submitRegistration({later: true})") {{t('app.programs.save_and_finish')}}
            button.button.save_and_continue(@click.prevent="submitRegistration", type='submit' disabled1="!form_valid")
              span(v-if="current_organization.id") {{t('app.programs.save_and_continue')}}
              span(v-else-if="registration.isCorrectionRequired()") {{t('app.programs.save_and_submit')}}
              span(v-else-if="registration.isCompleted()") {{t('app.buttons.save')}}
              span(v-else) {{t('app.programs.continue')}}

            .not-saved(v-html="t('app.registration.do_not_double_click')")
          .clearfix
</template>
<script>
  import helper from '../edit_helper.js'
  import save_helper from '../save_registration_helper.js'
  import {saveReg, fetchExisting} from 'templates/registrations/edit.js'
  import { v4 as uuidv4 } from 'uuid';

  const REG_NESTED_MAP = {
    registration_sections:        ['section_id',        'id'],
    registration_section_options: ['section_option_id', 'id', 'choice_ids', 'eligibility_requirement'],
    registration_addons:          ['addon_id',          'id', 'choice_ids', 'eligibility_requirement', 'other_amount'],
    registration_agreements:      ["agreement_id",      'id', "first_accepted", "second_accepted", "first_name", "second_name"],
    registration_student_transfers: [],
    registration_sending_schools: [],
    registration_transfer_reasons: [],
    registration_transfer_agreements: [],
  }

  export default {
    mixins: [helper, save_helper],
    props: ['form', 'editTpl', 'mapper_registration_id', 'transferForm'],
    data(){
      const now = new Date().getTime()
      return {
        bottom: false,
        saving: false, // prevent sending 2 requests
        form_valid: true,
        last_save_time: now,
        last_notify_time: now,
        formId: uuidv4(),
      }
    },
    computed: {
      cancelLink() {
        if(this.$route.meta.new_reg || this.registration.isDraft()){
          return `${this.get_locale()}/registrations`
        } else {
          return `${this.get_locale()}/registrations/${this.registration.id}/summary`
        }
      },
      errorsList(){
        return this.form && Object.entries(this.form.errors).filter(e=>e[1].length>0)
      },
    },
    watch: {
      // we do auto save only on drafts
      // when anything has changed and do save after 30 seconds
      // then we need to no notify each 60 seconds
      "state.current_reg.touch"(){
        this.form_valid = true
        if (this.creating_provisioned) return
        if (!this.registration.isStillPending()) return
        if(this.enable_autosave){
          const now = new Date().getTime()
          if (this.last_save_time < now - 30*1000){
            let opts = {skipRedirect: true, later: true}
            this.submitRegistration(opts)
            this.last_save_time = now
          }
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    },
    destroy() {
      window.removeEventListener('scroll', this.updateScroll)
    },
    methods: {
      updateScroll() {
        // in jQuery: if(($(window).scrollTop() + 600) > ($(document).height() - $(window).height())){
        if((window.pageYOffset + 600) > (document.body.scrollHeight - document.body.clientHeight)){
          this.bottom = true
        }else{
          this.bottom = false
        }
      },
      async checkValid(){
        if (!this.form) return
        this.form_valid = await this.form.validate()

        if (this.registration.isStillPending()){
          const sect=this.registration.registration_sections.some(rs=>!rs._destroy)
          if (!sect){
            let o = {}
            for(let i=0; i<this.registration.registration_sections.length; i++){
              o[`section-input-${i}`] = ["required"]
            }
            this.form.setErrors(o)
            this.form_valid = false
          }
        }
        return this.form_valid;
      },
      renderErrors(){
        this.$notification.open({
          message: "Required Information Missing",
          description: "Please complete all required fields on the page"
        })

        let node = document.querySelector(".error")
        if(!node){
          node = document.querySelector(".agreements")
        }
        if (node) node.parentNode.scrollIntoView()
        console.log("errors:",  this.errorsList)
      },
      // next fields should be always set
      firstAndLastNameAreSet(){
        const errs = {}
        for (const node of this.form.$el.querySelectorAll('[data-always_required]')){
          if (this.isBlank(node.value)){
            errs[node.dataset.vid] = ["required"]
          }
        }
        if (Object.keys(errs).length>0){
          this.form.setErrors(errs)
          this.$nextTick(_=> this.renderErrors())
          return false
        }
        return true
      },
      transfer_agreement_validation(){
        const agreement = this.registration.registration_transfer_agreements
        let o = {}
        if(agreement){
          if(!agreement[0].accepted){
            o[`transfer-accepted-input`] = ["required"]
            this.form.setErrors(o)
            this.form_valid = false
            this.renderErrors()
            return false
          }
          if(agreement[0].firstname == ""){
            o[`transfer-firstname-input`] = ["required"]
            this.form.setErrors(o)
            this.form_valid = false
            this.renderErrors()
            return false
          }
        }
        return true
      },
      async submitRegistration({later, skipRedirect}) {
        const formBlocks = this.registration["registration_form_blocks"] || [];

        const getBlockName = (blockName) => {
          const block = formBlocks.find(b => b.form_block && b.form_block.name === blockName);
          return block?.entity_attrs || {};
        };

        // Enhanced: requires field presence if expected
        const getNameString = (attrs, requiredFields = []) => {
          const names = [];

          if (requiredFields.includes("first_name")) {
            if (!attrs.first_name) return null;
            names.push(attrs.first_name);
          } else if (attrs.first_name) {
            names.push(attrs.first_name);
          }

          if (requiredFields.includes("middle_name")) {
            if (!attrs.middle_name) return null;
            names.push(attrs.middle_name);
          } else if (attrs.middle_name) {
            names.push(attrs.middle_name);
          }

          if (requiredFields.includes("last_name")) {
            if (!attrs.last_name) return null;
            names.push(attrs.last_name);
          } else if (attrs.last_name) {
            names.push(attrs.last_name);
          }

          return names.filter(Boolean).map(n => n.trim().toLowerCase()).join(' ');
        };

        const participantBlock = formBlocks.find(block => block.style === "Product::FormBlock::PartPerson");
        const participantAttrs = participantBlock?.entity_attrs || {};
        const requiredAttrs = participantBlock?.form_block?.required_attrs || [];
        const participantName = getNameString(participantAttrs, requiredAttrs);
        console.log("participantName", participantName);

        const firstParentName = getNameString(getBlockName("Parent/Guardian"));
        const secondParentName = getNameString(getBlockName("Second Parent/Guardian"));

        const agreements = this.registration["registration_agreements"] || [];

        const errors = {};
        let isValid = false;

        for (const agreement of agreements) {
          if (agreement.agreement.agreement_type !== "agreement") continue;

          const agreementId = agreement.agreement_id;
          const { first_signature_type, second_signature_type, validate_signature } = agreement.agreement;

          // First Signature
          if (validate_signature) {
            const inputFirstName = (agreement.first_name || "").trim().toLowerCase();
            const expectedFirstName =
              first_signature_type === "older_than" ? participantName : firstParentName;

            console.log(`Expected First Name: "${expectedFirstName}"`);
            console.log(`User Signature Input: "${inputFirstName}"`);

            if (expectedFirstName && inputFirstName !== expectedFirstName && !later) {
              errors[`first-parent-input-${agreementId}`] = ["required"];
              isValid = true;
            } else {
              errors[`first-parent-input-${agreementId}`] = null;
            }
          }

          // Second Signature
          if (validate_signature && second_signature_type) {
            const inputSecondName = (agreement.second_name || "").trim().toLowerCase();
            let expectedSecondName = "";

            if (first_signature_type === "older_than") {
              expectedSecondName = second_signature_type === "parent" ? firstParentName : participantName;
            } else {
              expectedSecondName = second_signature_type === "parent" ? secondParentName : participantName;
            }

            if (expectedSecondName && inputSecondName !== expectedSecondName && !later) {
              errors[`second-parent-input-${agreementId}`] = ["required"];
              isValid = true;
            } else {
              errors[`second-parent-input-${agreementId}`] = null;
            }
          }
        }
        
        if (!this.registration.flowId) this.registration.flowId = Date.now();
        if (this.saving) return
      
        if (!later && !(await this.checkValid())){
          return this.renderErrors()
        }
        if (!this.firstAndLastNameAreSet()) return
        if(this.registration.program.allow_student_transfers && !later){
          if (this.registration.accept_transfer === null) {
            return this.renderErrors()
          }
        } else {
          if (this.registration.accept_transfer && !this.transfer_agreement_validation()) return
        }
        
        if (later && this.registration.no_autosave) return
        if (isValid) {
          this.form.setErrors(errors);
          this.renderErrors();
          return false;
        }
        this.saving = true
        const doRedirect = !skipRedirect
        const person_id = this.registration.person_id < 1 ? null : this.registration.person_id
        const params = {
          history: window.visits,
          vue: true,
          errorsList: `${this.errorsList}/${Object.keys(this.form.errors).length}`,
          temp_reg: window.$reg,
          flow_id: this.registration.flowId,
          edit_json_request_id: this.registration.request_id,
          program_id: this.registration.program_id,
          person_id: person_id,
          // setting id for any case :)
          person_attributes: {person_id: person_id, id: person_id},
          invite: this.registration.invite,
          registration_sections_attributes: {},
          registration_section_options_attributes: {},
          registration_form_blocks_attributes: {},
          registration_agreements_attributes: {},
          registration_addons_attributes: {},
          registration_student_transfers_attributes: {},
          registration_sending_schools_attributes: {},
          registration_transfer_reasons_attributes: {},
          registration_transfer_agreements_attributes: {},
          id: this.registration.id,
          accept_transfer: this.registration.accept_transfer,
          form_id: this.formId,
          mapper_vertical_insurance: this.mapper_registration_id,
          registration_transfers_attributes: this.registration.registration_transfers,
          new_student_transfer: true
          // new_student_transfer: this.allow_new_student_transfer
        }
        if (later)        params.save_as_draft = 'true';
        if (skipRedirect) params.skipRedirect  = 'true';
        if (this.$route.params.organization_id) params.save_as_draft = null;

        // collect all registration nesting data with _attributes
        for (const reg_attr in REG_NESTED_MAP){
          console.log("reg_attr", reg_attr, this.registration[reg_attr])
          const attrs = REG_NESTED_MAP[reg_attr]
          for (let i = 0; i < this.registration[reg_attr].length; i++) {
            params[`${reg_attr}_attributes`][i] = {registration_id: this.registration.id}
            params[`${reg_attr}_attributes`][i]._destroy = this.registration[reg_attr][i]._destroy || false
            for (let a of attrs) {
              params[`${reg_attr}_attributes`][i][a] = this.registration[reg_attr][i][a] === null ? null : this.registration[reg_attr][i][a]
            }
          }
        }
      
        this.PrepareRegFBParams(this.registration, params)

        if (doRedirect) NProgress.start();
        try{
          const session = {
            program_id: this.$route.params.id,
            curr_org_id: this.state.current_org.id,
          }
          const json = await saveReg(this.registration, params, session)

          if (json.completed) {
            if (json.redirect) {
              if (window.visits) window.visits.push(`replace ${json.redirect}`)
              window.history.replaceState({turbolinks: false,url: window.location.href}, document.title,json.redirect)
            }
            if (doRedirect){
              Turbolinks.visit(json.redirect)
            }else{
              this.mapResponseToData(json.id)
              this.showSaveNotification(params)
            }
          } else {
            NProgress.done();
            let msg = (json.errors && json.errors[0]) || {}
            if (msg.description) msg = msg.description
            // FamilyID.Views.FlashMessage.showMessages({error: msg})
            console.log("error occurred", json)
            this.notify({
              message: "Sorry, error happened.",
              description: msg
            })
          }
        }catch(errorData){
          console.log("errorData:", errorData)
          NProgress.remove();
          this.notify({
            message: "Sorry, problem occurred.",
            description: errorData
          })
        }
        this.saving = false
      },
      showSaveNotification(params){
        const now = new Date().getTime()
        if (params.id){
          if (this.last_notify_time < now - 60*1000){
            this.notify({
              message: "All your updates have been saved.",
            })
            this.last_notify_time = now
          }

        }else{
          this.notify({
            message: "We have saved a draft of your registration.",
            description: "You can find this draft under the Not Submitted Registrations category on the Registrations tab."
          })
        }
      },
      
      // we need to set id of new registration_section to the form
      async mapResponseToData(id){
        this.registration.id = id
        const map = {
          registration_sections:        "section_id",
          registration_addons:          "addon_id",
          registration_section_options: "section_option_id",
          registration_form_blocks:     "form_block_id",
          registration_agreements:      "agreement_id",
          registration_transfers:       "transfer_id",
        }
        const new_reg = await fetchExisting(id, this.$route.params.organization_id, Object.keys(map))
        
        const transfer = this.registration.registration_transfer
        transfer.id = new_reg.registration_transfers[0].id
        let hash;
        for (const reg_block in map){
          const conn_attribute = map[reg_block]
          const reg_block_data = new_reg[reg_block]
          hash = {}
          for (const new_row of reg_block_data) hash[new_row[conn_attribute]] = new_row // builds dict of {form_block_id=> form_block}
          for (const old_row of this.registration[reg_block]){
            const new_object = hash[old_row[conn_attribute]]
            if (old_row._destroy){ old_row.id = null; old_row.entity_id=null}
            if (reg_block==='registration_form_blocks' && new_object){
              // reset cache on registration form block entity
              // NOTE: switching off, but leaving code for easier restoration
              // if (old_row.entity_id === -1) old_row.form_block.prefetch_new_element = new Date().getTime()/1000
              // if (old_row.entity_id && old_row.entity_id !== new_object.entity_id){
              //   console.error("something wrong... ", old_row.entity_id, new_object.entity_id)
              // }
              // very bad spagetty hack. Should be fixed. Done in a hurry before vacation :)
              if (old_row.style === "Product::FormBlock::PartPersonSchool"){
                this.registration.person.graduation_id = new_object.entity.id
              }
              old_row.entity_id   = new_object.entity_id
              old_row.entity_type = new_object.entity_type
              if (old_row.entity_id) old_row.entity_attrs.id = old_row.entity_id // on autosave we need to set entity_attrs.id

              const fb_id = new_object.form_block_id
              if (window.$reg.temp_rfb[fb_id] && window.$reg.temp_rfb[fb_id][0]){
                console.log("concern and comments new_object", new_object)
                window.$reg.temp_rfb[fb_id][0].id           = new_object.id
                window.$reg.temp_rfb[fb_id][0].entity_id    = new_object.entity_id
                // window.$reg.temp_rfb[fb_id][0].entity_attrs = new_object.entity_attrs
                // window.$reg.temp_rfb[fb_id][0].custom_attrs = new_object.custom_attrs
              }
            }
            if (typeof old_row.id === "number") continue;
            if (new_object) old_row.id = new_object.id
          }
        }

        if (!this.registration.person_id || this.registration.person_id === -1){
          this.registration.new_person_was = true
          this.$emit('reload')
        }
        this.registration.state     = new_reg.state
        this.registration.person_id = new_reg.person_id
        console.log("new_reg", new_reg)
      },
      isDesktop(){
        return window.innerWidth > 909
      },
      notify(hash){
        this.isDesktop() && this.$notification.open(hash)
      },
    },
  }
</script>
<style scoped>
  .floating-block{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0 !important;
    z-index: 100;
  }
  .floating-block section{
    max-width: 60.625em;
    margin-right: auto;
    margin-left: auto;
  }
</style>
